export default __webpack_public_path__ + "static/media/img_zilanmu.15a81016.png";